import {createSelector, Selector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

import {BREADCRUMBS_SLICE} from './constants';
import {IBreadcrumbsSliceState} from './types';

const rootSelector: Selector<TAppState, IBreadcrumbsSliceState> = (state: TAppState) => state[BREADCRUMBS_SLICE];

export const selectBreadcrumbsData = (entityName: string) => createSelector(
    rootSelector,
    (dataState: IBreadcrumbsSliceState) => dataState[entityName]?.breadcrumbs,
);
